module.exports = __webpack_public_path__ + "media/assets/images/flags/bi-b00998dbf4b1d136f6b37598b23affc1.svg";